import { z } from 'zod'
import { workSchema } from './schemas'

export enum OrderPlace {
  SHIPMENT = 'SHIPMENT',
  WAREHOUSE = 'WAREHOUSE',
  SHORTAGE = 'SHORTAGE',
  SEWING = 'SEWING',
  CUTTING = 'CUTTING',
  INTERNAL = 'INTERNAL',
  EYELET = 'EYELET',
  DISPATCHED = 'DISPATCHED',
}

export enum WorkType {
  CUTTING = 'CUTTING',
  SEWING = 'SEWING',
  SEWING_LOCKSTITCH = 'SEWING_LOCKSTITCH',
  SEWING_DOUBLE_NEEDLE = 'SEWING_DOUBLE_NEEDLE',
  EYELET = 'EYELET',
}

export enum SewingWorkType {
  SEWING_LOCKSTITCH = 'SEWING_LOCKSTITCH',
  SEWING_DOUBLE_NEEDLE = 'SEWING_DOUBLE_NEEDLE',
}

export type NewWork = z.infer<typeof workSchema>
export type UpdateWork = z.infer<typeof workSchema> & {
  id: string
}

export type Work = NewWork & {
  id: string
  createdAt: string
  updatedAt: string
}

export type WorkTableItem = Omit<Work, 'createdAt' | 'updatedAt'> & {
  createdAt: Date
  updatedAt: Date
}
